import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
export const Body = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eddaic70"
} : {
  target: "eddaic70",
  label: "Body"
})(process.env.NODE_ENV === "production" ? {
  name: "nac1mi",
  styles: "display:flex;flex-direction:column;row-gap:2px"
} : {
  name: "nac1mi",
  styles: "display:flex;flex-direction:column;row-gap:2px/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJvZHkuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQytCIiwiZmlsZSI6IkJvZHkuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5leHBvcnQgY29uc3QgQm9keSA9IHN0eWxlZC5kaXYgYFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICByb3ctZ2FwOiAycHg7XG5gO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9Qm9keS5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});